(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/company-details/components/company-details-form/components/addresses.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/company-details/components/company-details-form/components/addresses.js');
"use strict";


const ADDRESS_TYPES = svs.ticket_partner.companyDetails.constants.ADDRESS_TYPES;
const _React = React,
  useContext = _React.useContext,
  Fragment = _React.Fragment;
const getAddressByType = svs.ticket_partner.companyDetails.utils.getAddressByType;
const Address = svs.ticket_partner.companyDetails.components.companyDetailsForm.components.Address;
const Addresses = () => {
  const _useContext = useContext(svs.ticket_partner.CompanyDetailsContext),
    state = _useContext.state;
  const addresses = state.companyDetails.addresses;
  const BILLING = ADDRESS_TYPES.BILLING,
    VISITING = ADDRESS_TYPES.VISITING,
    LEGAL = ADDRESS_TYPES.LEGAL;
  return React.createElement(Fragment, null, React.createElement(Address, {
    adress: getAddressByType(addresses, VISITING)
  }), React.createElement(Address, {
    adress: getAddressByType(addresses, BILLING)
  }), React.createElement(Address, {
    adress: getAddressByType(addresses, LEGAL),
    disableOnEdit: true
  }));
};
svs.ticket_partner.companyDetails.components.companyDetailsForm.components.Addresses = Addresses;

 })(window);